/* eslint-disable no-use-before-define */
import {
  Sms as SMSIcon,
  VoiceChat as VoiceChatIcon,
  Dashboard as DashboardIcon,
  Settings as SettingsIcon,
  DonutLarge as ReferralIcon,
  PermPhoneMsg as RateCallIcon,
  DialerSip as DialerSipIcon,
  VerifiedUser as VerifyCallerIcon,
  Info as InfoIcon,
  Call as CallIcon,
  Redeem as RedeemIcon,
  Dialpad as DialpadIcon,
  Email as EmailIcon,
  SupervisedUserCircle as PartnerIcon,
  PollOutlined as ServicesIcon,
  ShowChart as RatesIcon,
  ConfirmationNumber as DIDsIcon
} from '@material-ui/icons';
import {
  PieChart as PieChartIcon,
  Voicemail as VoiceMailIcon,
  CreditCard as BuyCreditIcon,
  GitBranch as BridgeIcon,
  Package as ResourceIcon,
  User as PersonIcon,
  Users as CustomerIcon
} from 'react-feather';

const CompanyNameShort =
  JSON.parse(window.localStorage.getItem('CompanyNameShort')) || 'Vezeti';

export const customerSides = [
  {
    subheader: 'Overview',
    items: [
      {
        title: 'Get Started',
        icon: PieChartIcon,
        href: '/app/get-started'
      },
      {
        title: 'Dashboard',
        icon: DashboardIcon,
        href: '/app/dashboard'
      }
    ]
  },
  {
    subheader: 'Management',
    items: [
      {
        title: 'Buy Credit',
        icon: BuyCreditIcon,
        href: '/app/buy-credit'
      },
      {
        title: 'Voicemail Messages',
        icon: VoiceMailIcon,
        href: '/app/voicemail'
      },
      {
        title: `${CompanyNameShort} Numbers`,
        icon: DialpadIcon,
        href: `/app/${CompanyNameShort.toLowerCase()}-numbers`
      },

      {
        title: 'SIP Accounts',
        icon: DialerSipIcon,
        href: '/app/sip-account'
      },
      {
        title: 'Conference Bridge',
        icon: BridgeIcon,
        href: '/app/conference-bridge'
      },
      // {
      //   title: 'Bulk SMS',
      //   icon: SMSIcon,
      //   href: '/app/bulk-sms'
      // },
      // {
      //   title: 'Voice Broadcast',
      //   icon: VoiceChatIcon,
      //   href: '/app/voice-broadcast'
      // },
      {
        title: 'Rates: Call | SMS | Voice',
        icon: RateCallIcon,
        href: '/app/rates'
      },
      {
        title: 'Transfer Credit',
        icon: RedeemIcon,
        href: '/app/transfer-credit'
      },
      {
        title: 'Verify CallerIDs',
        icon: VerifyCallerIcon,
        href: '/app/verify-caller'
      },
      {
        title: 'User Calls Log',
        icon: CallIcon,
        href: '/app/user-calls-log'
      }
    ]
  },
  {
    subheader: 'Pages',
    items: [
      {
        title: 'Referral',
        href: '/app/referral',
        icon: ReferralIcon
      },
      {
        title: 'Resources',
        href: '/app/resources',
        icon: ResourceIcon
      },
      {
        title: 'Settings',
        href: '/app/settings',
        icon: SettingsIcon
      },
      {
        title: 'Dashboard Info',
        href: '/app/dashboard-info',
        icon: InfoIcon
      },
      {
        title: 'Email Template',
        href: '/app/templates',
        icon: EmailIcon
      }
    ]
  }
];

export const adminSides = [
  {
    subheader: 'General',
    items: [
      {
        title: 'Dashboard',
        href: '/admin/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Call Rates',
        href: '/admin/call-rates',
        icon: RatesIcon
      },
      {
        title: 'Account',
        href: '/admin/account',
        icon: PersonIcon
      }
    ]
  },
  {
    subheader: 'CRM',
    items: [
      {
        title: 'Customer',
        href: '/admin/customer',
        icon: CustomerIcon
      },
      {
        title: 'Partner',
        href: '/admin/partner',
        icon: PartnerIcon
      },
      {
        title: 'DID',
        href: '/admin/DID',
        icon: DIDsIcon
      },
      {
        title: 'Service Income',
        href: '/admin/service-income',
        icon: ServicesIcon
      }
    ]
  },
  {
    subheader: 'History',
    items: [
      {
        title: 'Call Log',
        href: '/admin/call-log',
        icon: CallIcon
      },
      {
        title: 'Funding',
        href: '/admin/funding',
        icon: RedeemIcon
      }
    ]
  }
];
